import { ModalCustom } from "components/ModalCustom";
import { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Required } from "components/Required";
import { Controller, useForm } from "react-hook-form";
import temaPadrao from "_config/temas/estilo/base";
import { PrimaryButton } from "components/Button/style";
import { yupResolver } from "@hookform/resolvers/yup";
import { alterarDespachante } from "../../validate/validator";
import { DropdownSelect, IOptions } from "components/DropdownSelect";
import { ContainerForm } from "./style";
import { IDespachante } from "../../Interfaces/IDespachante";

interface Props {
  show: boolean;
  handleClose: () => void;
  onSubmitUnitario: () => void;
  onSubmitLote: () => void;
  despachanteOptions: IOptions[];
  setDespachanteDetranEscolhido: (despachante: null | any) => void;
  tipoSubmit: "LOTE" | "UNITARIO";
  listaDespachantes: IDespachante[];
  despachanteDetranEscolhido: number;
}

export function ModalAlterarDespachante({
  show,
  handleClose,
  onSubmitUnitario,
  onSubmitLote,
  despachanteOptions,
  setDespachanteDetranEscolhido,
  tipoSubmit,
  listaDespachantes,
  despachanteDetranEscolhido,
}: Props) {
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors, isSubmitted },
  } = useForm({
    resolver: yupResolver(alterarDespachante),
  });

  useEffect(() => {
    reset({
      despachante: undefined,
    });
    setValue("despachante", 0);
  }, [show]);

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Alterar Despachante"
      centered
    >
      <form
        onSubmit={handleSubmit(() => {
          if (tipoSubmit === "UNITARIO") {
            onSubmitUnitario();
            return;
          }
          onSubmitLote();
        })}
      >
        <ContainerForm>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label
                  style={{ color: temaPadrao.colors.neutral.neutral70 }}
                >
                  Despachante <Required />
                </Form.Label>
                <Controller
                  control={control}
                  name="despachante"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      options={despachanteOptions}
                      title=""
                      selectedValue={value}
                      onSelect={(value) => {
                        onChange(value);
                        if (!value) {
                          setDespachanteDetranEscolhido(null);
                          return;
                        }
                        const despachante = listaDespachantes.filter(
                          (despachante) => despachante.id == value
                        );

                        if (despachante.length) {
                          setDespachanteDetranEscolhido(despachante[0].id);
                          return;
                        }

                        setDespachanteDetranEscolhido(null);
                      }}
                      searchable
                      gapDropdownContainer="0"
                      required
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
        </ContainerForm>
        <div className="d-flex justify-content-between gap-4 mt-4">
          <PrimaryButton
            style={{ width: "14rem" }}
            outline
            variante="primary"
            onClick={handleClose}
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton
            style={{ width: "14rem" }}
            type="submit"
            disabled={!despachanteDetranEscolhido}
          >
            Salvar
          </PrimaryButton>
        </div>
      </form>
    </ModalCustom>
  );
}
